import { getBrand, getBrandInfo, spaceGradeCodeMap, spaceGradeNameMap, useSpaceQuotaContext } from '@lighthouse/shared'
import { add, isAfter } from 'date-fns'
import React, { useMemo } from 'react'
import styled from 'styled-components'

interface SpaceGradeTagProps {
    value: number
    isLimitHidden?: boolean
    style?: React.CSSProperties
}

const SCxContainer = styled.span`
    padding: 2px 6px;
    /* height: 20px; */
    line-height: 18px;
    font-size: var(--font-size-sm);
    color: var(--color-theme-7);
    background-color: var(--color-theme-3);
    border-radius: 4px;
    flex-shrink: 0;
    font-weight: 400;
`
export const SpaceGradeTag: React.FunctionComponent<SpaceGradeTagProps> = ({ value, isLimitHidden = true, style }) => {
    const { quota } = useSpaceQuotaContext()
    const name = useMemo(() => {
        const INFO = getBrandInfo()
        const version = INFO.space.gradeVersions[value]
        return spaceGradeNameMap[version]
    }, [value])

    const isExpiringSoon = useMemo(() => {
        if (!quota || !quota.expiredAt || quota.currentVersionCode === 0 || quota.expiredAt === -1) {
            return
        }
        return isAfter(add(Date.now(), { days: 7 }), quota.expiredAt)
    }, [quota])

    if (quota && isLimitHidden && quota.currentVersionCode && quota.currentVersionCode >= value) {
        return null
    }

    return <SCxContainer style={style}>{name + (isExpiringSoon ? ' | 即将到期' : '')}</SCxContainer>
}
